import API from '@/shared/plugins/Api/API'
import Metrics from './Metrics'
import Logs from './Logs'

class CC extends API {
  constructor (id) {
    super(id)
    this.metrics = new Metrics(id)
    this.logs = new Logs(id)
  }
}
export default CC
